import _typeof from '@babel/runtime/helpers/typeof';
import colors from '../theme/foundations/colors.js';
import { __DEV__ } from '@chakra-ui/utils';
var LogType;
/**
 * Logs info, warning or error messages to the console via `console` functions.
 * Note: Only logs in development.
 */

(function (LogType) {
  LogType["warning"] = "warning";
  LogType["error"] = "error";
  LogType["info"] = "info";
})(LogType || (LogType = {}));
var logger = function logger(type, message, component, condition) {
  // Don't do anything in production.
  // This is wrapped in a production check for better dead code elimination.
  if (__DEV__) {
    // If a condition exists and it is false, return.
    if (_typeof(condition) !== undefined && condition === false) {
      return;
    } // If console does not exist, return.

    if (typeof console === 'undefined') {
      return;
    }
    var componentString = "".concat(typeof component === 'string' ? "[".concat(component, "] ") : ""); // Construct the message

    var messageWithColor = "%c@hausgold/designsystem%c %c".concat(type.charAt(0).toUpperCase() + type.slice(1), "%c: ").concat(componentString).concat(message);
    var messageWithoutColor = "@hausgold/designsystem ".concat(type.charAt(0).toUpperCase() + type.slice(1), ": ").concat(componentString).concat(message);
    switch (type) {
      case LogType.error:
        // eslint-disable-next-line no-console
        console.error(messageWithColor, "color: ".concat(colors.blue['400']), "color: ".concat(colors.red['900']), "color: inherit", "color: inherit"); // Throw an error and catch it immediately to improve debugging
        //
        // A consumer can use "pause on caught exceptions", see:
        // https://github.com/facebook/react/issues/4216

        try {
          throw Error(messageWithoutColor); // eslint-disable-next-line no-empty
        } catch (x) {}
        break;
      case LogType.info:
        // eslint-disable-next-line no-console
        console.info(messageWithColor, "color: ".concat(colors.blue['400']), "color: ".concat(colors.gray['200']), "color: inherit", "color: inherit");
        break;
      case LogType.warning:
        // eslint-disable-next-line no-console
        console.warn(messageWithColor, "color: ".concat(colors.blue['400']), "color: ".concat(colors.yellow['400']), "color: inherit", "color: inherit");
        break;
    }
  }
};
/**
 * Shorthand warning function for `logger`
 */

var warn = function warn(message, component, condition) {
  return logger(LogType.warning, message, component, condition);
};
/**
 * Shorthand error function for `logger`
 */

var error = function error(message, component, condition) {
  return logger(LogType.error, message, component, condition);
};
export { LogType, logger as default, error, warn };